import React , { Component } from 'react';
import {browserHistory,Link} from 'react-router';
import { Modal, Button } from 'react-bootstrap';

import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Notifications extends Component{
	constructor(props){
		super(props);
		this.state={
			notifications: [],
			empty_status:false,
			deleteAll_modal:false,
		}
		this.deleteAll=this.deleteAll.bind(this);
		this.clearNotif=this.clearNotif.bind(this);
		this.deleteModal=this.deleteModal.bind(this);
		this.close=this.close.bind(this);
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href="/web/notifications";
		}
		if(!localStorage.token && !localStorage.user_id)
		{
			localStorage.setItem('notifications','/notifications');
			browserHistory.push('/login');
		}
		else
		{
			var data1={id:localStorage.user_id,token:localStorage.token,from:'mobile_web'};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'getpnotifications',
				data:{req:data2},
				success:function(data)
				{
					if(data.status==='success')
					{
						if(data.notifications.length > 0)
						{
							this.setState({
								notifications: data.notifications,
							});	
						}
						else
						{
							this.setState({
								empty_status:true,
							});
						}
					}
					else if(data.status==='error' && data.message==='Token mismatch')
					{
						localStorage.clear();
						localStorage.setItem('notifications','/notifications');
						browserHistory.push('/login');
					}
			
				}.bind(this),
				error:function(err)
				{
				
				}
			});
		}
	}
	close()
	{
		this.setState({
			deleteAll_modal:false,
		});
	}
	deleteModal()
	{
		this.setState({
			deleteAll_modal:true,
		});
	}
	deleteAll()
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'deleteAllNotifications',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						empty_status:true,
						deleteAll_modal:false,
					});
				}
				
			}.bind(this),
			error:function(err)
			{
			
			}
		});
	}
	// clearNotif(id,token,push_id,from)
	clearNotif(push_id)
	{
		var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,push_id:push_id}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'clearNotif',
			data:{req:data2},
			success:function(data)
			{

			},
			error:function(err)
			{
			
			}
		})
	}
	// 

	render(){
		document.title="Notifications | AquaDeals";
		var notifications = this.state.notifications.map(function(data,index){
			return(
				<div className="notification_item">
					{data.link==='internal' ? <Link onClick={()=>this.clearNotif(data.id)} to={data.url ? data.url : '/'} style={{cursor:'pointer'}}>
						{data.title ? <h5 className="noty_title">{data.title}</h5> : <h5 className="noty_title">&nbsp;</h5>}
						{data.content ? <h5 className="noty_content">{data.content}</h5> : <h5 className="noty_content">&nbsp;</h5>}
						{data.date ? <p className="noty_date">{data.date}</p> : <p className="noty_date">&nbsp;</p>}
					</Link> : <a onClick={()=>{this.clearNotif(data.id)}} href={data.url ? data.url : '/'} target="_blank" style={{cursor:'pointer'}}>
						{data.title ? <h5 className="noty_title">{data.title}</h5> : <h5 className="noty_title">&nbsp;</h5>}
						{data.content ? <h5 className="noty_content">{data.content}</h5> : <h5 className="noty_content">&nbsp;</h5>}
						{data.date ? <p className="noty_date">{data.date}</p> : <p className="noty_date">&nbsp;</p>}
					</a>}
				</div>
			)
		}.bind(this))
		return(
			<div className="mob_deals mob_notifications_page">
				<div className="page_hdr">
					<div className="" style={{paddingRight: '15px',paddingLeft: '15px',marginRight: 'auto',marginLeft: 'auto'}}>
						<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=" "/></i></Link> Notifications</h5>
						<a href="/" className="home_logo1">
							<img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" />
						</a>
						{!this.state.empty_status ? <a className="noty_emptybtn" onClick={()=>{this.deleteModal()}}><img alt="" src={baseAssets+'icons/web_icons/del_bin3.png'} /></a> : ''}
					</div>
				</div>
				<div className="pag_cntnt">&nbsp;</div>
				<section className="container-fluid">
					{this.state.empty_status ? <div className="noty_empty">No Notifications Available</div> : notifications}
				</section>
				<Modal show={this.state.deleteAll_modal} onHide={this.close}  >
					<Modal.Header closeButton>
			    		<Modal.Title>Alert</Modal.Title>
			  		</Modal.Header>
					<Modal.Body>
			  			<h4>Do you want to remove all notifications? </h4>
			  		</Modal.Body>
			  		<Modal.Footer className="mob_cart_confirm">
			  			<Button className="" onClick={this.close}>NO</Button>
			  			<a><Button className="" onClick={()=>{this.deleteAll()}}>YES</Button></a>
			  		</Modal.Footer>
				</Modal>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Accounts/Notifications.js
 **/